import { z } from 'zod'

/**
 * order cancel schema
 */
export const orderCancelSchema = z.object({
  reason: z.string().nonempty('Please select a reason'),
})
